import React, { useState, useEffect } from 'react';
import useToken from 'hooks/useToken';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';

import { Col, Row } from 'react-bootstrap';

import Greetings from './Greeting/Greetings';
import ListaDatosFacturacion from './ListaDatosFacturacion';



const AjustesFacturacion = () => {

    const { token, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();
    const { showErrorToast } = useToast();

    const [showModalDatosFiscales, setShowModalDatosFiscales] = useState(false);
    const [showModalNuevo, setShowModalNuevo] = useState(false);


    /**
   * Se ejecuta la primera vez
   */
    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();
    },);

    /**
     * Verifica los permisos
     */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);

                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                //
            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }

    return (
        <>            
            <Row>
                <Col className="col-12">
                    <Greetings
                        showModalNuevo={showModalNuevo}
                        setShowModalNuevo={setShowModalNuevo}
                        showModalDatosFiscales={showModalDatosFiscales}
                        setShowModalDatosFiscales={setShowModalDatosFiscales}
                    />
                </Col>
                <Col className="col-12">
                    <ListaDatosFacturacion
                        showModalNuevo={showModalNuevo}
                        setShowModalNuevo={setShowModalNuevo}
                        showModalDatosFiscales={showModalDatosFiscales}
                        setShowModalDatosFiscales={setShowModalDatosFiscales}
                    />
                </Col>
            </Row>
        </>
    );
};

export default AjustesFacturacion;